import { CAAMetricsDatasource } from '../datasources/CAAMetricsDatasource'

export function caaMetricsRepositoryAdapter(
  caaMetricsDatasouce: CAAMetricsDatasource
) {
  return {
    async getPatientCAAMetricsWeek(params: {
      patientId: string
      personaName?: string
      date: string
    }) {
      return await caaMetricsDatasouce.getPatientCAAMetricsWeek(params)
    },
    async getPatientCAAMetricsMonth(params: {
      patientId: string
      personaName?: string
      month: number
      year: number
    }) {
      return await caaMetricsDatasouce.getPatientCAAMetricsMonth(params)
    },
    async getPatientCAAMetricsSemester(params: {
      patientId: string
      personaName?: string
      period: number
      year: number
    }) {
      return await caaMetricsDatasouce.getPatientCAAMetricsSemester(params)
    },
    async getPatientCAAMetricsYear(params: {
      patientId: string
      personaName?: string
      year: number
    }) {
      return await caaMetricsDatasouce.getPatientCAAMetricsYear(params)
    },
    async getOperationalCAAMetricsPatientWeek(params: {
      personaName?: string
      date: string
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsPatientWeek(
        params
      )
    },
    async getOperationalCAAMetricsPatientMonth(params: {
      personaName?: string
      month: number
      year: number
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsPatientMonth(
        params
      )
    },
    async getOperationalCAAMetricsPatientSemester(params: {
      personaName?: string
      period: number
      year: number
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsPatientSemester(
        params
      )
    },
    async getOperationalCAAMetricsPatientYear(params: {
      personaName?: string
      year: number
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsPatientYear(
        params
      )
    },
    async getOperationalCAAMetricsTherapistWeek(params: {
      personaName?: string
      date: string
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsTherapistWeek(
        params
      )
    },
    async getOperationalCAAMetricsTherapistMonth(params: {
      personaName?: string
      month: number
      year: number
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsTherapistMonth(
        params
      )
    },
    async getOperationalCAAMetricsTherapistSemester(params: {
      personaName?: string
      period: number
      year: number
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsTherapistSemester(
        params
      )
    },
    async getOperationalCAAMetricsTherapistYear(params: {
      personaName?: string
      year: number
    }) {
      return await caaMetricsDatasouce.getOperationalCAAMetricsTherapistYear(
        params
      )
    }
  }
}
